import { createStreamHook } from '@/service/ws/use-web-socket-with-proto'
import { TokenUnlockEvent, TokenUnlockStream } from '@/types/generated/public_api'

export const useTokenUnlockStream = createStreamHook<TokenUnlockStream, TokenUnlockEvent>({
  channelKey: 'tokenUnlockStream',
  extractResponse: (message) => message.data?.tokenUnlockEvent,
  getPayloadDeps: () => [], // no fields — single global, unfiltered subscription
  listenerChannelKey: 'tokenUnlockStream',
})
